
import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, State } from "vuex-class"

import TextAreaToggleExpand from "@/components/Fields/TextAreaToggleExpand.vue"

import api from "@/services/api"
import { CaseDetails } from "@/types"
const caseStore = namespace("cases")

@Component({
	components: {
		"text-area-expand": TextAreaToggleExpand
	}
})
export default class PostComment extends Vue {
	@Prop()
	public currentCase!: CaseDetails;

	@State tenantEnabledFeatures!: { [key: string]: boolean }

	private comment: string = "";

	public async postComment () {
		if (this.comment?.length > 0 && /\S/.test(this.comment) && this.currentCase.id) {
			await api.postComment(this.currentCase.id,
				this.comment.trim(),
				null,
				!!this.tenantEnabledFeatures["richText"]
			)
			this.comment = ""
		}
	}

	private get postCommentBoxStyle () {
		return {
			width: this.comment.length > 0 ? "46px" : "0",
			transition: "width 0.2s"
		}
	}
}
